import RadioButton from '@ben/orion/radio-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useWatch } from 'react-hook-form';
import styled, { css, useTheme } from 'styled-components';

export enum EnrollmentDateType {
  NONE = 'none',
  FIXED = 'fixed',
  DYNAMIC = 'dynamic',
  MANUAL = 'manual',
}

interface DateTypeSelectorProps {
  label: string;
  value: EnrollmentDateType;
  exclude?: EnrollmentDateType[];
  onChange: (value: EnrollmentDateType) => void;
  dateType?: string;
}

export const EnrollmentDateTypeSelector = ({
  label,
  value,
  exclude,
  onChange,
  dateType,
}: DateTypeSelectorProps) => {
  const theme = useTheme();
  const newBenefitType = useWatch({ name: 'newBenefitType', exact: true });

  return (
    <Container>
      <Typography variant={TypographyVariant.bodyLg2}>{label}</Typography>
      <ContentRow>
        {Object.values(EnrollmentDateType).map(
          (type) =>
            !exclude?.includes(type) && (
              <RadioButton
                key={type}
                label={type.charAt(0).toUpperCase() + type.slice(1)}
                checked={
                  value === type || (type === EnrollmentDateType.NONE && !value)
                }
                backgroundColor={theme.palette.neutral['00']}
                value={type}
                onChange={() => onChange(type)}
              />
            )
        )}
      </ContentRow>
      {dateType === 'end' &&
        newBenefitType === 'LOAN' &&
        value === EnrollmentDateType.NONE && (
          <ErrorTypography variant={TypographyVariant.bodyMd1}>
            You need to set an enrolment end date for loan benefits
          </ErrorTypography>
        )}
    </Container>
  );
};

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `};
`;

const ErrorTypography = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.palette.error.main};
  `};
`;

export const ContentRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `};
`;
